import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  return { headers: { Authorization: `Bearer ${token}` } };
}

export const getPlan = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/billing/plan`, auth);
  return response.data;
};

export const listPlans = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/billing/plans`, auth);
  return response.data;
};

export const getHistory = async () => {
  const auth = getAuthHeaders();
  const response = await axios.get(`${BASE_URL}/api/billing/history`, auth);
  return response.data;
};

export const getBankDetails = async (currency, planId, interval = 'month') => {
  const auth = getAuthHeaders();
  const params = { currency };
  if (planId) params.planId = planId;
  if (interval) params.interval = interval;
  const response = await axios.get(`${BASE_URL}/api/billing/bank-details`, { ...auth, params });
  return response.data;
};

export const bankTransferRequest = async (body) => {
  const auth = getAuthHeaders();
  const payload = { ...body, interval: body.interval ?? 'month' };
  const response = await axios.post(`${BASE_URL}/api/billing/bank-transfer-request`, payload, auth);
  return response.data;
};

/**
 * Upload proof of bank transfer (image or PDF). Uses multipart/form-data.
 * @param {string} paymentId - Payment _id from bankTransferRequest response
 * @param {File} file - Image or PDF file
 */
export const bankTransferProof = async (paymentId, file) => {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  const formData = new FormData();
  formData.append('paymentId', paymentId);
  formData.append('proof', file);
  const response = await axios.post(`${BASE_URL}/api/billing/bank-transfer-proof`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const createCheckoutSession = async (body) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/billing/create-checkout-session`, body, auth);
  return response.data;
};

export const createPortalSession = async () => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/billing/create-portal-session`, {}, auth);
  return response.data;
};

export const updateBillingSettings = async (body) => {
  const auth = getAuthHeaders();
  const response = await axios.put(`${BASE_URL}/api/billing/settings`, body, auth);
  return response.data;
};

export const createFlutterwavePayment = async (body) => {
  const auth = getAuthHeaders();
  const response = await axios.post(`${BASE_URL}/api/billing/create-flutterwave-payment`, body, auth);
  return response.data;
};
